import GoogleMapsContainer from "../../../../Components/Miscellaneous/Maps/GoogleMaps/GoogleMapsContainer";

const GoogleMap = () => {
  return <GoogleMapsContainer />;
};

export default GoogleMap;
